<template>
  <section
    ref="section21"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="18"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >
      <figure class="flex w-full max-w-lg flex-col gap-11">
        <figure class="flex gap-3">
          <div><v-icon icon="contract-edit" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="mb-3 text-heading-3-desktop">Zazidljivost parcele</div>
            <div class="text-body-regular text-black-40">
              Izberete lahko samo eno možnost.
            </div>
          </div>
        </figure>
        <form method="POST" :action="routes.submitForm" id="select-buildibility-status">
          <v-csrf-token></v-csrf-token>
          <figure class="ml-auto mr-auto flex w-full max-w-lg flex-col gap-8">
            <ul class="flex flex-col gap-4">
              <li class="w-full" v-for="(option, onOfficeEnum) in stepData.bebaubar_nach_options" :key="'buildability-'+onOfficeEnum">
                <div :class="['radio group flex items-center', (validationErrors.bebaubar_nach ? 'has-errors' : '')]">
                  <input
                    :id="onOfficeEnum"
                    type="radio"
                    :value="onOfficeEnum"
                    name="bebaubar_nach"
                    class="hidden"
                    v-model="buildabilityStatus"
                  />
                  <label
                    :for="onOfficeEnum"
                    class="w-full text-body-medium-button"
                  >
                    <div class="label">{{ option }}</div>
                    <div class="icon">
                      <v-icon icon="radio-unchecked" class="unchecked"></v-icon>
                      <v-icon icon="radio-checked" class="checked"></v-icon>
                    </div>
                  </label>
                </div>
              </li>
            </ul>
          </figure>
        </form>
      </figure>
    </main>
    <v-add-listing-foot>
      <a
        @click="submitForm('select-buildibility-status')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      buildabilityStatus: null,
    };
  },
  mounted() {
    this.buildabilityStatus = this.stepData.bebaubar_nach
  },
  computed: {
    validated() {
      if(this.buildabilityStatus == null) return false
      
      return true;
    }
  },
  methods: {
    submitForm(formId) {
      if(this.validated) document.getElementById(formId).submit();
    },
  },
};
</script>